/*
  Convert the accepters object into an array of slots that contain everything needed for a view.
 */

(function () {
  var FeatureFlag, extractNames, getLetter;

  extractNames = require("@CommonFrontendBackend/Utils/ExtractNames");

  getLetter = require("./GetLetter");

  FeatureFlag = require("@CommonFrontendBackend/FeatureFlag").FeatureFlag;

  module.exports = function (accepters, getFullName, userIconFactory, usingFeature) {
    var accepter,
      getEmptyIcon,
      getUserIcon,
      i,
      index,
      j,
      k,
      len,
      len1,
      makeAcceptedSlot,
      makeEmptySlot,
      makePrefilledSlot,
      name,
      prefilledNames,
      ref,
      ref1,
      remaining,
      slots,
      taken,
      isUsingInlineForm;
    isUsingInlineForm = !usingFeature(FeatureFlag.OptOutNewEditor);
    getUserIcon = function (name, index, accepters) {
      if (isUsingInlineForm) {
        return userIconFactory.createReactIcon(extractNames(name));
      } else {
        return userIconFactory.create(extractNames(name), {
          mixIndex: index,
          mixTotal: accepters.number,
        });
      }
    };
    getEmptyIcon = function (index, accepters) {
      if (isUsingInlineForm) {
        return userIconFactory.createReactIcon();
      } else {
        return userIconFactory.createEmpty({
          mixIndex: index,
          mixTotal: accepters.number,
        });
      }
    };
    makeAcceptedSlot = function (index, name, acceptedAt) {
      return {
        displayName: name,
        name: name,
        icon: getUserIcon(name, index, accepters),
        accepted: true,
        acceptedAt: acceptedAt,
      };
    };
    makePrefilledSlot = function (index, name) {
      return {
        displayName: name,
        name: name,
        icon: getUserIcon(name, index, accepters),
        accepted: false,
      };
    };
    makeEmptySlot = function (index) {
      return {
        displayName: "Accepter " + getLetter(index),
        name: null,
        icon: getEmptyIcon(index, accepters),
        accepted: false,
      };
    };
    if (accepters.finalisedAccepters == null) {
      accepters.finalisedAccepters = [];
    }
    prefilledNames = _.clone(accepters.prefilledNames);
    slots = [];
    ref = accepters.finalisedAccepters;
    for (index = i = 0, len = ref.length; i < len; index = ++i) {
      accepter = ref[index];
      slots.push(makeAcceptedSlot(index, accepter.name, accepter.acceptedAt));
      _.pull(prefilledNames, accepter.name);
    }
    if (accepters.enablePrefilledNames) {
      for (index = j = 0, len1 = prefilledNames.length; j < len1; index = ++j) {
        name = prefilledNames[index];
        if (name != null ? name.length : void 0) {
          slots.push(makePrefilledSlot(index + accepters.finalisedAccepters.length, name));
        }
      }
    }
    taken = slots.length;
    remaining = accepters.number - slots.length;
    if (remaining > 0) {
      for (index = k = 0, ref1 = remaining; 0 <= ref1 ? k < ref1 : k > ref1; index = 0 <= ref1 ? ++k : --k) {
        slots.push(makeEmptySlot(index + taken));
      }
    }
    return slots;
  };
}.call(this));
